import React from "react";
import styles from "./StatusBadge.module.css";
import classnames from "classnames";

interface StatusBadgeProps {
    status: "upcoming" | "past" | "cancelled";
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
    const getStatusStyle = (): string => {
        switch (status) {
            case "upcoming":
                return styles.upcoming;
            case "past":
                return styles.past;
            case "cancelled":
                return styles.cancelled;
        }
    };

    const getStatusText = (): string => {
        return status.charAt(0).toUpperCase() + status.slice(1);
    };

    return (
        <div className={classnames(styles.wrapper, getStatusStyle())}>
            <span className={styles.title}>{getStatusText()}</span>
        </div>
    );
};
